import type { FilterModel } from '../query/filter';

export interface TableApi<T> {
    getSelectedRows: () => T[];
    clearSelection: () => void;
    setSelected: (ids: string[]) => void;
    toggleSelected: (id: string) => void;
    getRows: () => T[];
    refresh: () => void;
    getFilters: () => FilterModel;
    setFilters: (m: FilterModel) => void;
    collapseAll: () => void;
    getRowCount: () => number;
    getTotalCount: () => number | undefined;
}

export function lazyTableApi<T>(get: () => TableApi<T> | null): TableApi<T> {
    return {
        getSelectedRows: () => get()?.getSelectedRows() ?? [],
        clearSelection: () => get()?.clearSelection(),
        setSelected: (ids) => get()?.setSelected(ids),
        toggleSelected: (id) => get()?.toggleSelected(id),
        getRows: () => get()?.getRows() ?? [],
        refresh: () => get()?.refresh(),
        getFilters: () => get()?.getFilters() ?? {},
        setFilters: (m) => get()?.setFilters(m),
        collapseAll: () => get()?.collapseAll(),
        getRowCount: () => get()?.getRowCount() ?? 0,
        getTotalCount: () => get()?.getTotalCount(),
    };
}
